import { programApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROGRAM_ACTION_TYPE = createNamedActions('programs', {
  GET_PROGRAMS: 'GET_PROGRAMS',
  CREATE_PROGRAM: 'CREATE_PROGRAM',
  EDIT_PROGRAM: 'EDIT_PROGRAM',
  DELETE_PROGRAM: 'DELETE_PROGRAM',
  ACTIVATE_PROGRAM: 'ACTIVATE_PROGRAM',
});

const programsSchema = new schema.Entity('data', {}, { idAttribute: 'programId' });

export const getProgramsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programApi.getPrograms(params);

  return dispatch({
    type: PROGRAM_ACTION_TYPE.GET_PROGRAMS,
    payload: normalize(data, [programsSchema]).entities.data,
  });
});

export const createProgramAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programApi.createProgramV2(params);

  return dispatch({
    type: PROGRAM_ACTION_TYPE.CREATE_PROGRAM,
    payload: data,
  });
});

export const editProgramAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programApi.editProgramV2(params);

  return dispatch({
    type: PROGRAM_ACTION_TYPE.EDIT_PROGRAM,
    payload: data,
  });
});

export const deleteProgramAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programApi.deleteProgram(params);

  return dispatch({
    type: PROGRAM_ACTION_TYPE.DELETE_PROGRAM,
    payload: data,
    meta: params,
  });
});

export const activateProgramAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await programApi.activateProgram(params);

  return dispatch({
    type: PROGRAM_ACTION_TYPE.ACTIVATE_PROGRAM,
    payload: data,
  });
});
